import Transfer from './components/Transfer';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'transfer',
  pluginComponent: Transfer,
});
